import { render, staticRenderFns } from "./ControlRadio.vue?vue&type=template&id=c8bb40e0&"
import script from "./ControlRadio.vue?vue&type=script&lang=js&"
export * from "./ControlRadio.vue?vue&type=script&lang=js&"
import style0 from "./ControlRadio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports